import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '10px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const TextItem = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontFamily: 'body',
  fontStyle: 'normal',
  fontWeight: 'normal',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};

export const LinkItem = {
  color: 'alpha.400',
  fontWeight: 'bold',
  textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
};
